/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Table of Contents for posts */
(function () {
    const articleBody = document.querySelector('.gh-article-body');
    if (!articleBody) return;

    // Add IDs to all headings in the article body
    const allHeadings = articleBody.querySelectorAll('h1, h2, h3, h4, h5, h6');
    allHeadings.forEach(function (heading, index) {
        if (!heading.id) {
            // Create ID from heading text
            const text = heading.textContent.trim();
            const id = text
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-|-$/g, '');
            heading.id = id || 'heading-' + index;
        }
    });

    const tocNav = document.getElementById('toc-nav');
    if (!tocNav) return;

    // Find headings for TOC (only h2 and h3)
    const headings = articleBody.querySelectorAll('h2, h3');

    if (headings.length === 0) {
        // No headings - show article title as only item
        const articleTitle = document.querySelector('.gh-article-title');
        if (articleTitle) {
            const link = document.createElement('a');
            link.href = '#';
            link.className = 'gh-toc-link active';
            link.textContent = articleTitle.textContent;

            link.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });

            tocNav.appendChild(link);
        }
        return;
    }

    // Generate TOC
    headings.forEach(function (heading) {

        // Create TOC link
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.className = 'gh-toc-link';
        link.textContent = heading.textContent;

        // Add level class for styling
        if (heading.tagName === 'H3') {
            link.classList.add('level-3');
        }

        // Handle click
        link.addEventListener('click', function (e) {
            e.preventDefault();
            heading.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Update URL hash without jumping
            history.pushState(null, null, '#' + heading.id);
        });

        tocNav.appendChild(link);
    });

    // Track scroll position and highlight active heading
    let ticking = false;
    const tocLinks = tocNav.querySelectorAll('.gh-toc-link');

    function updateActiveLink() {
        let activeHeading = null;
        const scrollPosition = window.scrollY + 100;
        const isLegalPage = document.querySelector('.gh-legal-page') !== null;

        // Find the heading that's currently in view
        headings.forEach(function (heading) {
            const rect = heading.getBoundingClientRect();
            const offsetTop = window.scrollY + rect.top;

            if (offsetTop <= scrollPosition) {
                activeHeading = heading;
            }
        });

        // On legal pages, if active heading is H3+, find parent H2
        if (isLegalPage && activeHeading && activeHeading.tagName !== 'H2') {
            // Find the nearest previous H2
            let currentElement = activeHeading.previousElementSibling;
            while (currentElement) {
                if (currentElement.tagName === 'H2') {
                    activeHeading = currentElement;
                    break;
                }
                currentElement = currentElement.previousElementSibling;
            }
        }

        // Update active class on TOC links
        tocLinks.forEach(function (link) {
            link.classList.remove('active');
            if (activeHeading && link.href.includes('#' + activeHeading.id)) {
                link.classList.add('active');
            }
        });

        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(updateActiveLink);
            ticking = true;
        }
    });

    // Initial update
    updateActiveLink();
})();

/* Heading anchor links with copy to clipboard */
(function () {
    const articleBody = document.querySelector('.gh-article-body');
    if (!articleBody) return;

    // Find all headings in the article body
    const headings = articleBody.querySelectorAll('h1, h2, h3, h4, h5, h6');
    if (headings.length === 0) return;

    // Link icon SVG
    const linkIconSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    headings.forEach(function (heading) {
        // Skip if heading doesn't have an ID
        if (!heading.id) return;

        // Create anchor link
        const anchor = document.createElement('a');
        anchor.className = 'gh-heading-anchor';
        anchor.setAttribute('aria-label', 'Copy link to clipboard');
        anchor.innerHTML = linkIconSvg;

        // Create tooltip
        const tooltip = document.createElement('span');
        tooltip.className = 'gh-heading-anchor-tooltip';
        tooltip.textContent = 'Copied to clipboard!';
        anchor.appendChild(tooltip);

        // Handle click - copy link to clipboard
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            // Build the full URL with hash
            const url = window.location.origin + window.location.pathname + '#' + heading.id;

            // Copy to clipboard
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(function () {
                    // Show tooltip
                    tooltip.classList.add('show');

                    // Hide tooltip after 2 seconds
                    setTimeout(function () {
                        tooltip.classList.remove('show');
                    }, 2000);
                }).catch(function (err) {
                    console.error('Failed to copy link:', err);
                });
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = url;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                    tooltip.classList.add('show');
                    setTimeout(function () {
                        tooltip.classList.remove('show');
                    }, 2000);
                } catch (err) {
                    console.error('Failed to copy link:', err);
                }
                document.body.removeChild(textArea);
            }
        });

        // Add anchor to heading
        heading.appendChild(anchor);
    });
})();

/* Newsletter CTA form handling */
(function () {
    const form = document.querySelector('[data-members-form="subscribe"]');
    if (!form) return;

    const messageEl = form.querySelector('.gh-newsletter-cta-message');
    const emailInput = form.querySelector('[data-members-email]');
    const submitButton = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        const email = emailInput.value.trim();
        if (!email) return;

        // Disable button and show loading state
        submitButton.disabled = true;
        submitButton.textContent = 'Subscribing...';
        messageEl.textContent = '';
        messageEl.className = 'gh-newsletter-cta-message';

        // Submit to Ghost members API
        fetch('/members/api/send-magic-link/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                emailType: 'subscribe'
            })
        })
        .then(function (response) {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Subscription failed');
        })
        .then(function () {
            // Success
            messageEl.textContent = 'Success! Check your email to confirm.';
            messageEl.classList.add('success');
            emailInput.value = '';
            submitButton.textContent = 'Subscribed!';

            // Reset button after 3 seconds
            setTimeout(function () {
                submitButton.textContent = 'Join the Community';
                submitButton.disabled = false;
            }, 3000);
        })
        .catch(function (error) {
            // Error
            messageEl.textContent = 'Something went wrong. Please try again.';
            messageEl.classList.add('error');
            submitButton.textContent = 'Join the Community';
            submitButton.disabled = false;
        });
    });
})();

/* Back to top button */
(function () {
    const backToTopButton = document.getElementById('back-to-top');
    if (!backToTopButton) return;

    // Show/hide button based on scroll position
    window.addEventListener('scroll', function () {
        if (window.scrollY > 300) {
            backToTopButton.classList.add('visible');
        } else {
            backToTopButton.classList.remove('visible');
        }
    });

    // Scroll to top when clicked
    backToTopButton.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
})();

/* Format tags - remove dashes and title case */
(function () {
    const tags = document.querySelectorAll('.gh-article-tag[data-tag-name]');

    tags.forEach(function (tag) {
        const originalName = tag.getAttribute('data-tag-name');

        // Remove dashes and convert to title case
        const formattedName = originalName
            .split('-')
            .map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');

        tag.textContent = formattedName;
    });
})();

/* Full-width image sidebar freeze control */
(function () {
    var articleWrapper = document.querySelector('.gh-article-wrapper');
    if (!articleWrapper) return;

    var fullWidthImages = articleWrapper.querySelectorAll('.kg-width-full');
    if (fullWidthImages.length === 0) return;

    var leftSidebar = document.querySelector('.gh-toc-sidebar');
    var rightSidebar = document.querySelector('.gh-right-sidebar');
    var leftInner = leftSidebar ? leftSidebar.querySelector('.gh-toc-inner') : null;
    var rightInner = rightSidebar ? rightSidebar.querySelector('.gh-right-sidebar-inner') : null;

    if (!leftSidebar && !rightSidebar) return;

    var STICKY_TOP = 50;
    var BUFFER = 50; // Extra buffer to freeze sidebar before it reaches the image
    var imageZones = [];
    var mergedZones = [];
    var currentlyFrozen = false;
    var currentlyHidden = false;
    var wrapperTop = 0;
    var zonesReady = false; // Flag to track when image zones are accurately calculated
    var scrollTicking = false; // Guard to prevent multiple checks per frame
    var sidebarHasBeenShown = false; // Track if sidebar was ever visible (for scroll-up behavior)

    // Estimate sidebar height before it's fully rendered
    function estimateSidebarHeight() {
        return (leftInner ? leftInner.offsetHeight : null) || (rightInner ? rightInner.offsetHeight : null) || 300;
    }

    // Check if first full-width image is near the top of the article (before images load)
    function checkForEarlyImage() {
        var firstImage = fullWidthImages[0];
        if (!firstImage) return false;

        var content = articleWrapper.querySelector('.gh-content');
        if (!content) return false;

        var contentTop = content.getBoundingClientRect().top;
        var imageTop = firstImage.getBoundingClientRect().top;
        var distanceFromContentStart = imageTop - contentTop;

        // If the image is within 600px of the content start, consider it "early"
        return distanceFromContentStart < 600;
    }

    // Immediately hide sidebars if there's an early full-width image
    if (checkForEarlyImage()) {
        if (leftSidebar) leftSidebar.classList.add('sidebar-hidden');
        if (rightSidebar) rightSidebar.classList.add('sidebar-hidden');
        currentlyHidden = true;
    }

    // Merge consecutive image zones that are too close together for the sidebar to fit between them
    function mergeImageZones(zones, sidebarHeight) {
        if (zones.length === 0) return [];

        // Sort zones by top position
        var sorted = zones.slice().sort(function (a, b) { return a.top - b.top; });
        var merged = [{ top: sorted[0].top, bottom: sorted[0].bottom }];

        for (var i = 1; i < sorted.length; i++) {
            var current = sorted[i];
            var last = merged[merged.length - 1];

            // If gap between zones is smaller than sidebar height + buffer, merge them
            var gap = current.top - last.bottom;
            if (gap < sidebarHeight + BUFFER) {
                // Extend the last zone to include this one
                last.bottom = Math.max(last.bottom, current.bottom);
            } else {
                // Gap is large enough for sidebar - keep as separate zone
                merged.push({ top: current.top, bottom: current.bottom });
            }
        }

        return merged;
    }

    function calculateImageZones() {
        var wrapperRect = articleWrapper.getBoundingClientRect();
        wrapperTop = window.scrollY + wrapperRect.top;

        imageZones = Array.prototype.map.call(fullWidthImages, function (img) {
            var rect = img.getBoundingClientRect();
            return {
                top: window.scrollY + rect.top,
                bottom: window.scrollY + rect.top + rect.height
            };
        });

        // Merge zones that are too close together
        var sidebarHeight = estimateSidebarHeight();
        mergedZones = mergeImageZones(imageZones, sidebarHeight);
    }

    function hideSidebar(sidebar) {
        if (!sidebar) return;
        sidebar.classList.add('sidebar-hidden');
    }

    function showSidebar(sidebar) {
        if (!sidebar) return;
        sidebar.classList.remove('sidebar-hidden');
    }

    function freezeSidebar(sidebar, inner) {
        if (!sidebar || !inner) return;
        var sidebarRect = sidebar.getBoundingClientRect();
        var innerRect = inner.getBoundingClientRect();
        inner.style.top = (innerRect.top - sidebarRect.top) + 'px';
        sidebar.classList.add('sidebar-frozen');
    }

    function resumeSidebar(sidebar, inner) {
        if (!sidebar || !inner) return;
        inner.style.top = '';
        sidebar.classList.remove('sidebar-frozen');
    }

    function checkSidebarState() {
        var sidebarHeight = estimateSidebarHeight();
        var stickyPosition = window.scrollY + STICKY_TOP;
        var stickyBottom = stickyPosition + sidebarHeight;

        // First: Check if ANY zone is "early" (sidebar wouldn't fit above it)
        // These zones require hiding the sidebar until scrolled past
        var activeEarlyZone = null;
        for (var i = 0; i < mergedZones.length; i++) {
            var zone = mergedZones[i];
            // Zone is "early" if it starts before there's room for sidebar
            if (zone.top <= wrapperTop + sidebarHeight + BUFFER) {
                // Check if we're still within this early zone (haven't scrolled past it)
                if (stickyPosition < zone.bottom + BUFFER) {
                    activeEarlyZone = zone;
                    break;
                }
            }
        }

        if (activeEarlyZone) {
            // We're in an early zone region
            // Only hide if sidebar has never been shown yet
            // If it was shown before (user scrolled past), freeze instead
            if (!sidebarHasBeenShown) {
                // Sidebar hasn't been shown yet - hide it
                if (!currentlyHidden) {
                    hideSidebar(leftSidebar);
                    hideSidebar(rightSidebar);
                    currentlyHidden = true;
                }
                if (currentlyFrozen) {
                    resumeSidebar(leftSidebar, leftInner);
                    resumeSidebar(rightSidebar, rightInner);
                    currentlyFrozen = false;
                }
            } else {
                // Sidebar was shown before - freeze it instead of hiding
                if (currentlyHidden && zonesReady) {
                    showSidebar(leftSidebar);
                    showSidebar(rightSidebar);
                    currentlyHidden = false;
                }
                if (!currentlyFrozen && !currentlyHidden) {
                    freezeSidebar(leftSidebar, leftInner);
                    freezeSidebar(rightSidebar, rightInner);
                    currentlyFrozen = true;
                }
            }
            return;
        }

        // Then: Check for mid-article zones that need freezing
        // Skip early zones - they're only handled by hiding, never freezing
        var overlappingZone = null;
        for (var i = 0; i < mergedZones.length; i++) {
            var zone = mergedZones[i];
            // Skip zones that were early (they should have been handled above or scrolled past)
            if (zone.top <= wrapperTop + sidebarHeight + BUFFER) {
                continue;
            }
            if (stickyBottom > zone.top - BUFFER && stickyPosition < zone.bottom + BUFFER) {
                overlappingZone = zone;
                break;
            }
        }

        if (overlappingZone) {
            // Mid-article zone - show and freeze sidebar
            if (currentlyHidden && zonesReady) {
                showSidebar(leftSidebar);
                showSidebar(rightSidebar);
                currentlyHidden = false;
                sidebarHasBeenShown = true;
            }
            // Only freeze when sidebar is actually visible
            if (!currentlyFrozen && !currentlyHidden) {
                freezeSidebar(leftSidebar, leftInner);
                freezeSidebar(rightSidebar, rightInner);
                currentlyFrozen = true;
            }
        } else {
            // No overlap - show sidebar normally (only if zones are ready to prevent flash)
            if (currentlyHidden && zonesReady) {
                showSidebar(leftSidebar);
                showSidebar(rightSidebar);
                currentlyHidden = false;
                sidebarHasBeenShown = true;
            }
            if (currentlyFrozen) {
                resumeSidebar(leftSidebar, leftInner);
                resumeSidebar(rightSidebar, rightInner);
                currentlyFrozen = false;
            }
        }
    }

    // Wait for images to load before calculating zones
    var imagesToLoad = fullWidthImages.length;
    var imagesLoaded = 0;

    function onImageLoad() {
        imagesLoaded++;
        if (imagesLoaded >= imagesToLoad) {
            zonesReady = true;
            calculateImageZones();
            checkSidebarState();
        }
    }

    // Attach load handlers to images within full-width containers
    Array.prototype.forEach.call(fullWidthImages, function (container) {
        var img = container.querySelector('img');
        if (img) {
            if (img.complete) {
                onImageLoad();
            } else {
                img.addEventListener('load', onImageLoad);
                img.addEventListener('error', onImageLoad); // Count errors too
            }
        } else {
            onImageLoad(); // No img element, count as loaded
        }
    });

    // Also calculate on window load as fallback
    window.addEventListener('load', function () {
        zonesReady = true;
        calculateImageZones();
        checkSidebarState();
    });

    // Initial calculation (may be inaccurate before images load)
    calculateImageZones();

    window.addEventListener('scroll', function () {
        if (!scrollTicking) {
            scrollTicking = true;
            requestAnimationFrame(function() {
                checkSidebarState();
                scrollTicking = false;
            });
        }
    }, { passive: true });
    window.addEventListener('resize', function () {
        calculateImageZones();
        checkSidebarState();
    }, { passive: true });

    checkSidebarState();
})();